import { central, email, mapsUrl, tel } from "../data";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="wrap">
        <div className="footer-grid">
          <div className="footer-brand">
            <img src="/logo-dark.png" alt="FinTrust" width="3277" height="1171" />
            <p className="muted">
              Securitizadora desde 2019 e FIDC desde 2024. Antecipação de recebíveis e capital de
              giro para quem produz.
            </p>
          </div>

          <div className="footer-info">
            <h3>Endereço e horário</h3>
            <p>
              Rua Professor Pedro Viriato Parigot de Souza, 3901
              <br />
              Campo Comprido, Curitiba · PR
              <br />
              <a className="link" href={mapsUrl} target="_blank" rel="noreferrer">
                Ver no mapa
              </a>
            </p>
            <p>
              Segunda a sexta, das 8:00 às 17:30
              <br />
              <a className="link" href={tel(central.phone)}>
                {central.label}
              </a>
              <br />
              <a className="link" href={`mailto:${email}`}>
                {email}
              </a>
            </p>
          </div>

          <nav className="footer-social" aria-label="Redes sociais">
            <h3>Redes</h3>
            <a href="https://www.instagram.com/fintrust_investimentos/" target="_blank" rel="noreferrer">
              Instagram
            </a>
            <a href="https://www.linkedin.com/company/fintrust-investimentos" target="_blank" rel="noreferrer">
              LinkedIn
            </a>
          </nav>
        </div>

        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} FinTrust Investimentos</span>
          <p>
            Imagens via Wikimedia Commons, exibidas em preto e branco:{" "}
            <a href="https://commons.wikimedia.org/wiki/File:Curitiba_Skyline_2.jpg">“Curitiba Skyline 2”</a>, por
            Wilfredor, <a href="https://creativecommons.org/publicdomain/zero/1.0/deed.en">CC0</a>;{" "}
            <a href="https://commons.wikimedia.org/wiki/File:Largo_da_Ordem_-_Curitiba_PR_-_panoramio_(1).jpg">
              “Largo da Ordem - Curitiba PR”
            </a>
            , por Paulo JC Nogueira, <a href="https://creativecommons.org/licenses/by-sa/3.0">CC BY-SA 3.0</a>;{" "}
            <a href="https://commons.wikimedia.org/wiki/File:Igreja_NS_do_Pilar_Pitangui.jpg">“Igreja NS do Pilar Pitangui”</a>,
            por Wanildo Silva, <a href="https://creativecommons.org/licenses/by-sa/4.0">CC BY-SA 4.0</a>. Fotos dos serviços por Oli Dale, Janko
            Ferlič, rawpixel, Seth Schwiet e Breather, via Unsplash e Wikimedia Commons,{" "}
            <a href="https://creativecommons.org/publicdomain/zero/1.0/deed.en">CC0</a>.
          </p>
        </div>
      </div>
    </footer>
  );
}
